import { useNavigation } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { useQueryClient } from '@tanstack/react-query'
import { RootStackParamList } from './../../navigation/navigationTypes'
import { MenuStackParamList } from './../../navigation/navigator/MenuNavigator'
import { useAuth } from '@context'

interface useMenuResult {
  navigateToProfile: () => void
  navigateToScreen: (screen: keyof MenuStackParamList) => void
  signOut: () => void
}

export const useMenu = (): useMenuResult => {
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>()
  const queryClient = useQueryClient()
  const { signOut: authSignOut } = useAuth()

  const navigateToProfile = () => navigation.navigate('Profile')

  const navigateToScreen = (screen: keyof MenuStackParamList) => {
    // Navigation vers les écrans du menu
    switch (screen) {
      case 'Map':
        (navigation as any).navigate('Menu', { screen: 'Map' })
        break
      case 'Birthdays':
        (navigation as any).navigate('Menu', { screen: 'Birthdays' })
        break
      case 'Notes':
        (navigation as any).navigate('Menu', { screen: 'Notes' })
        break
      case 'Categories':
        (navigation as any).navigate('Menu', { screen: 'Categories' })
        break
      case 'Hashtags':
        (navigation as any).navigate('Menu', { screen: 'Hashtags' })
        break
      case 'RelationalColors':
        (navigation as any).navigate('Menu', { screen: 'RelationalColors' })
        break
      case 'Calendar':
        (navigation as any).navigate('Menu', { screen: 'Calendar' })
        break
      case 'KeepContact':
        (navigation as any).navigate('Menu', { screen: 'KeepContact' })
        break
      case 'ScheduledMessages':
        (navigation as any).navigate('Menu', { screen: 'ScheduledMessages' })
        break
      case 'QRCode':
        (navigation as any).navigate('Menu', { screen: 'QRCode' })
        break
      case 'Settings':
        (navigation as any).navigate('Menu', { screen: 'Settings' })
        break
      case 'ImportContacts':
        (navigation as any).navigate('Menu', { screen: 'ImportContacts' })
        break
      case 'ClassifyContacts':
        (navigation as any).navigate('Menu', { screen: 'ClassifyContacts' })
        break
      case 'MergeContacts':
        (navigation as any).navigate('Menu', { screen: 'MergeContacts' })
        break
      case 'Graph':
        (navigation as any).navigate('Menu', { screen: 'Graph' })
        break
      case 'Nearby':
        (navigation as any).navigate('Menu', { screen: 'Nearby' })
        break
      default:
        console.log(`Navigation vers ${screen}`)
    }
  }

  const signOut = () => {
    try {
      queryClient.clear()
      authSignOut()
    } catch (error) {
      console.error('Error in signOut:', error)
    }
  }

  return {
    navigateToProfile,
    navigateToScreen,
    signOut,
  }
}
